import { Action, createReducer, on } from '@ngrx/store';
import { IErrorCode } from '../../../_utils/models';
import { Role, RoleTypes, User, UserRole } from '../models/user-role.model';
import * as UserActions from './user.actions';

export const userFeatureKey = 'carm-user-role';

export interface State {
  roles: UserRole;
  user: User;
  nativeRoles: Role[];
  showProgramSwitchMenu: boolean;
  loading: boolean;
  loadingBusiness?: boolean;
  businessLoadSuccess?: boolean;
  businessLoadError?: boolean;
  success: boolean;
  error: IErrorCode;
}

export const initialState: State = {
  roles: null,
  user: null,
  loading: false,
  nativeRoles: null,
  showProgramSwitchMenu: false,
  success: false,
  error: null,
};

const userReducer = createReducer(
  initialState,
  on(UserActions.setTermConditionAccepted, (state) => ({...state, user: {...state.user, isPrivacyTermsConditionsAccepted: true}, loading: true})),
  on(UserActions.setTermConditionAPIAccepted, (state) => ({...state, user: {...state.user, isPrivacyTermsConditionsAPIAccepted: true}, loading: true})),
  on(UserActions.loadRoles, (state) => ({...state, loading: true, success: false})),
  on(UserActions.loadRoleByBusiness, (state) => ({...state, loading: true, success: false})),
  on(UserActions.loadRoleByBusinessProgram, (state) => ({...state, loadingBusiness: true, businessLoadSuccess: false, businessLoadError: null})),
  on(UserActions.loadRolesByBusinessProgramSuccess, (state, {data}) => ({...state,
                                                              roles: data.role,
                                                              user: data.user,
                                                              showProgramSwitchMenu: data.role.lastUsedRole &&
                                                                                     data.role.lastUsedRole.roleType !== RoleTypes.Orphan ? true : false,
                                                              businessLoadSuccess: true,
                                                              loadingBusiness: false,
                                                            })),
  on(UserActions.loadRolesByBusinessProgramFailure, (state, { error }) => ({...state, businessLoadError: error, loadingBusiness: false, businessLoadSuccess: false})),
  on(UserActions.loadNativeRoles, (state) => ({...state, loading: true, success: false})),
  on(UserActions.loadRolesSuccess, (state, {data}) => ({...state,
                                                          roles: data.role,
                                                          user: data.user,
                                                          showProgramSwitchMenu: data.role.lastUsedRole &&
                                                                                 data.role.lastUsedRole.roleType !== RoleTypes.Orphan ? true : false,
                                                          success: true,
                                                          loading: false,
                                                        })),
  on(UserActions.loadNativeRolesSuccess, (state, {data}) => ({...state,
                                                          nativeRoles: data.roles,
                                                          success: true,
                                                          loading: false,
                                                        })),
  on(UserActions.loadRolesFailure, (state, { error }) => ({...state, error, loading: false, success: false})),
  on(UserActions.loadNativeRolesFailure, (state, { error }) => ({...state, error, loading: false, success: false})),
  on(UserActions.clearUserInformation, (state) => ({...initialState})),
  on(UserActions.updateIsDefaultAddressExist, (state, {defaultExists, data}) => {
    if ( state && state.user ) {
      return ({...state, user: {...state.user, isDefaultAddressExist: defaultExists, lastName: data.lastName, firstName: data.firstName}});
    } else {
      return ({...state });
    }
  }),

  on(UserActions.toggleProgramMenu, (state, {data}) => {
    if ( state && state.user ) {
      return ({...state, showProgramSwitchMenu: data});
    } else {
      return ({...state });
    }
  }),

  on(UserActions.setCurrentRole, (state, {data}) => (
    { ...state, roles: {...state.roles, currentRole: data },  success: true, loading: false })),

  );

export function reducer(state: State | undefined, action: Action) {
    return userReducer(state, action);
}
